import React from 'react'
import ContentBrandHero from '../../../components/ContentBrandHero'

const MakeHeroWidget = ({ make, header, description }) => {
  return (
    <ContentBrandHero
      title={header}
      summary={description}
      img={
        make.heroImages && make.heroImages.length > 0
          ? make.heroImages[0]
          : null
      }
      bg={
        make.backgroundImages && make.backgroundImages.length > 0
          ? make.backgroundImages[0]
          : null
      }
      dark
    />
  )
}

export default MakeHeroWidget
